<template>
	<div class="row">
		<div class="col-md-12">
			<div class="box-body-payment mt-4">
				<b-form-group>
					<!--		SALE_CURRENCIES ROW			-->
					<b-row>
						<b-col cols="6">
							<b-row>
								<b-col cols="12" class="mb-4" v-for="(payment, index) in payments" :key="`saleCurrency-${index}`">
									<h4 class="mb-0 d-flex align-items-center paymentTitle">
										<span v-if="payment.currency.code === 'USD'" class="flag-icon flag-icon-us"></span>
										<span v-else-if="payment.currency.code === 'EUR'" class="d-inline-flex">
											<img :src="`${publicPath}img/eunion.png`" alt="europian union flag" style="width: 1.65rem;">
										</span>
										<span v-else-if="payment.currency.code === 'RUB'" class="flag-icon flag-icon-ru"></span>
										<span v-else-if="payment.currency.code === 'GBP'" class="flag-icon flag-icon-gb"></span>
										<span v-else-if="payment.currency.code === 'UZS'" class="flag-icon flag-icon-uz"></span>
										<b class="ml-2">{{payment.currency.name }}</b>
										<span v-if="index === 0" class="ml-4" style="color: orange; font-size: 1.3rem;">{{ totalSum }}</span>
										<span v-if="index === 0" class="ml-5" style="color: black"><b>{{ $t('xAtchot.title') }}</b></span>
									</h4>
									<b-input-group class="posPaymentInputGroup mt-1">
										<b-input-group-text slot="prepend" @click="giveRestSumToPayment(index, 'CASH')">
											<span>{{ payment.currency.name }}</span>
										</b-input-group-text>
										<b-form-input ref="CASH" :id="`popover-button-sync-${index}`" placeholder="Сумма денег" size="lg" style="color: black" v-model="payment.paymentMethods.find(method => method.paymentMethod.code === 'CASH').amount" @click="$event.target.select()" @focus="$event.target.select()"/>
										<b-input-group-append>
											<b-button @click="payment.paymentMethods.find(method => method.paymentMethod.code === 'CASH').amount = 0">
												<i class="fa fa-close"/>
											</b-button>
										</b-input-group-append>
									</b-input-group>
									<b-tooltip :target="`popover-button-sync-${index}`" title="Keyboard" triggers="focus">
										<b-row style="margin: 5px 0 0 0">
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('1', payment, 'CASH')">1</b-button>
											</b-col>
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('2', payment, 'CASH')">2</b-button>
											</b-col>
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('3', payment, 'CASH')">3</b-button>
											</b-col>
										</b-row>
										<b-row class="mt-1" style="margin: 5px 0 0 0">
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('4', payment, 'CASH')">4</b-button>
											</b-col>
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('5', payment, 'CASH')">5</b-button>
											</b-col>
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('6', payment, 'CASH')">6</b-button>
											</b-col>
										</b-row>
										<b-row class="mt-1" style="margin: 5px 0 0 0">
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('7', payment, 'CASH')">7</b-button>
											</b-col>
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('8', payment, 'CASH')">8</b-button>
											</b-col>
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('9', payment, 'CASH')">9</b-button>
											</b-col>
										</b-row>
										<b-row class="mt-1" style="margin: 5px 0 0 0">
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('.', payment, 'CASH')">,</b-button>
											</b-col>
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('0', payment, 'CASH')">0</b-button>
											</b-col>
											<b-col style="padding: 2px; margin: 2px">
												<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="trash(payment, 'CASH')"><=</b-button>
											</b-col>
										</b-row>
									</b-tooltip>
								</b-col>
							</b-row>
						</b-col>
						<b-col cols="6">
							<b-row>
								<b-col cols="12" class="mb-4" v-for="(payment, index) in payments" :key="`saleCurrency-${index}`">
									<div v-if="payment.currency.code === 'USD' || payment.currency.code === 'UZS'" :class="payment.currency.code === 'USD' ? 'mt50' : ''">
										<h4 class="mb-0 d-flex align-items-center paymentTitle">
											<span v-if="payment.currency.code === 'USD'" class="flag-icon flag-icon-us"></span>
											<span v-else-if="payment.currency.code === 'UZS'" class="flag-icon flag-icon-uz"></span>
											<b class="ml-2">{{payment.currency.name }}</b>
											<span v-if="payment.currency.code === 'USD'" class="ml-5" style="color: black"><b>{{ $t('xAtchot.cart') }}</b></span>
										</h4>
										<!--			BANK_CARD INPUT FOR UZS CURRENCY			-->
										<template v-if="payment.currency.code === 'UZS'">
											<!--			INPUT FOR "UZCARD"			-->
											<b-input-group v-if="payment.paymentMethods.find(method => method.paymentMethod.code === 'UZCARD')" class="posPaymentInputGroup mt-1">
												<b-input-group-text slot="prepend" style="cursor: pointer; padding: 0" @click="giveRestSumToPayment(index ,'UZCARD')">
													<span>
														<img :src="`${publicPath}img/pos-images/uzcard.png`" alt="UzCard" style="width: 3.5rem;">
													</span>
												</b-input-group-text>
												<b-form-input ref="UZCARD" placeholder="Сумма денег" style="color: black" :id="`popover-button-sync-uzsUzCard`" v-model="payment.paymentMethods.find(method => method.paymentMethod.code === 'UZCARD').amount" @click="$event.target.select()" @focus="$event.target.select()"/>
												<b-input-group-append>
													<b-button @click="payment.paymentMethods.find(method => method.paymentMethod.code === 'UZCARD').amount = 0">
														<i class="fa fa-close"/>
													</b-button>
												</b-input-group-append>
											</b-input-group>
											<b-tooltip :target="`popover-button-sync-uzsUzCard`" title="Keyboard" triggers="focus">
												<b-row style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('1', payment, 'UZCARD')">1</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('2', payment, 'UZCARD')">2</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('3', payment, 'UZCARD')">3</b-button>
													</b-col>
												</b-row>
												<b-row class="mt-1" style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('4', payment, 'UZCARD')">4</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('5', payment, 'UZCARD')">5</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('6', payment, 'UZCARD')">6</b-button>
													</b-col>
												</b-row>
												<b-row class="mt-1" style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('7', payment, 'UZCARD')">7</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('8', payment, 'UZCARD')">8</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('9', payment, 'UZCARD')">9</b-button>
													</b-col>
												</b-row>
												<b-row class="mt-1" style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('.', payment, 'UZCARD')">,</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('0', payment, 'UZCARD')">0</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="trash(payment, 'UZCARD')"><=</b-button>
													</b-col>
												</b-row>
											</b-tooltip>
											<!--			INPUT FOR "HUMO"			-->
											<b-input-group v-if="payment.paymentMethods.find(method => method.paymentMethod.code === 'HUMO')" class="posPaymentInputGroup mt-2">
												<b-input-group-text slot="prepend" style="cursor: pointer; padding: 0" @click="giveRestSumToPayment(index ,'HUMO')">
													<span>
														<img :src="`${publicPath}img/pos-images/humo_card.png`" alt="HumoCard" style="width: 3.5rem;">
													</span>
												</b-input-group-text>
												<b-form-input ref="HUMO" placeholder="Сумма денег" style="color: black" :id="`popover-button-sync-uzsHUMO`" v-model="payment.paymentMethods.find(method => method.paymentMethod.code === 'HUMO').amount" @click="$event.target.select()" @focus="$event.target.select()"/>
												<b-input-group-append>
													<b-button @click="payment.paymentMethods.find(method => method.paymentMethod.code === 'HUMO').amount = 0">
														<i class="fa fa-close"/>
													</b-button>
												</b-input-group-append>
											</b-input-group>
											<b-tooltip :target="`popover-button-sync-uzsHUMO`" title="Keyboard" triggers="focus">
												<b-row style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('1', payment, 'HUMO')">1</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('2', payment, 'HUMO')">2</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('3', payment, 'HUMO')">3</b-button>
													</b-col>
												</b-row>
												<b-row class="mt-1" style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('4', payment, 'HUMO')">4</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('5', payment, 'HUMO')">5</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('6', payment, 'HUMO')">6</b-button>
													</b-col>
												</b-row>
												<b-row class="mt-1" style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('7', payment, 'HUMO')">7</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('8', payment, 'HUMO')">8</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('9', payment, 'HUMO')">9</b-button>
													</b-col>
												</b-row>
												<b-row class="mt-1" style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('.', payment, 'HUMO')">,</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('0', payment, 'HUMO')">0</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="trash(payment, 'HUMO')"><=</b-button>
													</b-col>
												</b-row>
											</b-tooltip>
										</template>
										<!--			BANK_CARD INPUT FOR USD CURRENCY			-->
										<template v-if="payment.currency.code === 'USD'">
											<b-input-group v-if="payment.paymentMethods.find(method => method.paymentMethod.code === 'VISA')" class="posPaymentInputGroup mt-1">
												<b-input-group-text slot="prepend" style="cursor: pointer; padding: 0;" @click="giveRestSumToPayment(index ,'VISA')">
													<span>
														<img :src="`${publicPath}img/pos-images/visa_card.png`" alt="VisaCard" style="width: 3.5rem;">
													</span>
												</b-input-group-text>
												<b-form-input ref="VISA" placeholder="Сумма денег" style="color: black" :id="`popover-button-sync-usdVisa`" v-model="payment.paymentMethods.find(method => method.paymentMethod.code === 'VISA').amount" @click="$event.target.select()" @focus="$event.target.select()"/>
												<b-input-group-append>
													<b-button @click="payment.paymentMethods.find(method => method.paymentMethod.code === 'VISA').amount = 0">
														<i class="fa fa-close"/>
													</b-button>
												</b-input-group-append>
											</b-input-group>
											<b-tooltip :target="`popover-button-sync-usdVisa`" title="Keyboard" triggers="focus">
												<b-row style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('1', payment, 'VISA')">1</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('2', payment, 'VISA')">2</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('3', payment, 'VISA')">3</b-button>
													</b-col>
												</b-row>
												<b-row class="mt-1" style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('4', payment, 'VISA')">4</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('5', payment, 'VISA')">5</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('6', payment, 'VISA')">6</b-button>
													</b-col>
												</b-row>
												<b-row class="mt-1" style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('7', payment, 'VISA')">7</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('8', payment, 'VISA')">8</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('9', payment, 'VISA')">9</b-button>
													</b-col>
												</b-row>
												<b-row class="mt-1" style="margin: 5px 0 0 0">
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('.', payment, 'VISA')">,</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="insert('0', payment, 'VISA')">0</b-button>
													</b-col>
													<b-col style="padding: 2px; margin: 2px">
														<b-button size="lg" style="font-size: 25px" variant="outline-primary" block pill @click="trash(payment, 'VISA')"><=</b-button>
													</b-col>
												</b-row>
											</b-tooltip>
										</template>
									</div>
								</b-col>
								<b-col cols="12" style="margin-top: -20px; margin-bottom: 15px">
									<b-input-group>
										<template #prepend>
											<b-input-group-text>Билет</b-input-group-text>
										</template>
										<b-form-input
											v-model="ticket"
										></b-form-input>
									</b-input-group>
								</b-col>
								<b-col cols="12">
									<b-input-group>
										<template #prepend>
											<b-input-group-text>Полет</b-input-group-text>
										</template>
										<b-form-input
											v-model="flight"
										></b-form-input>
									</b-input-group>
								</b-col>
								<!-- COMMENT FOR PAYMENTS -->
								<b-col cols="12">
									<label for="paymentsComment">{{ $t('sale.sale') }}</label>
									<b-form-textarea
										id="paymentsComment"
										v-model="paymentComment"
										:placeholder="$t('sale.sale')"
										:rows="rows"
										max-rows="2"
									></b-form-textarea>
								</b-col>
							</b-row>
						</b-col>
					</b-row>
				</b-form-group>
			</div>
		</div>
	</div>
</template>


<script>
function precisionRoundMod(number, precision) {
	let factor = Math.pow(10, precision);
	let n = parseFloat(number);

	let difference = number * factor - Math.trunc(number * factor);
	if (difference < 1 && difference > 0) {
		let result = (Math.trunc(number * factor)) / factor;
		return result;
	} else {
		return n;
	}
	// return Math.round(n * factor) / factor;
}

import {mapState, mapActions} from 'vuex'

export default {
	name: 'PaymentMethod',
	props: {
		totalSum: [String, Number],
		openClicked: [Boolean],
		saleCurrencies: {
			type: Array,
			default: () => []
		},
		lastCurrencyRates: {
			type: Array,
			default: () => []
		}
	},
	data: () => {
		return {
			publicPath: process.env.BASE_URL,
			rows: 2,
			flight: '',
			ticket: '',
			/*dropdowns: {
				allMethods: []
			},*/
			isCertificate: false,
			isDebt: false,
			isSponsor: false,
			payments: [],
			paymentComment: '',
			lastDebtInput: '',
			lastSponsorInput: '',
			lastElementCode: 'CASH',
			confirmLastElementCode: 'CASH',
		}
	},
	computed: {
		computedBankCard: {
			get() {
				let val = this.payments.find(el => el.paymentMethod.code == 'BANK_CARD').amount
				if (Number.isInteger(parseFloat(val))) {
					return parseFloat(val)
				} else {
					return parseFloat(val).toFixed(2)
				}

			},
			set(value) {
				// Vue.set(this.payments.find(el => el.paymentMethod.code == 'BANK_CARD'), 'amount', value);
				/*if (parseFloat(value) < parseFloat(this.totalSum)) {
					let val2 = parseFloat(this.totalSum) - parseFloat(value)
					Vue.set(this.payments.find(el => el.paymentMethod.code == 'CASH'), 'amount', val2)
					this.isDebt = false
					this.isSponsor = false
				}*/
			}
		},
		cashComputed: {
			get() {
				let val = this.payments.find(el => el.paymentMethod.code == 'CASH').amount
				if (Number.isInteger(parseFloat(val))) {
					return parseFloat(val)
				} else {
					return parseFloat(val).toFixed(2)
				}

			},
			set(value) {
				// Vue.set(this.payments.find(el => el.paymentMethod.code == 'CASH'), 'amount', value);
				/*if (parseFloat(value) < parseFloat(this.totalSum)) {
					Vue.set(this.payments.find(el => el.paymentMethod.code == 'BANK_CARD'), 'amount',
						parseFloat(this.totalSum) - parseFloat(value));
					this.isDebt = false
					this.isSponsor = false
				}*/
			}
		},
		isOnlayn: {
			get() {
				return this.isOnlaynProdaja
			},
			set(value) {
				this.$store.commit('pos/setIsOnlaynProdaja', value)
			}
		},
		adressForDelivery: {
			get() {
				return this.clientAddress
			},
			set(value) {
				this.$store.commit('pos/setAddressDelivery', value)
			}
		},
		orderOfNumber: {
			get() {
				return this.orderNumber
			},
			set(value) {
				this.$store.commit('pos/setOrderNumber', value)
			}
		},
		clientN: {
			get() {
				return this.clientName
			},
			set(value) {
				this.$store.commit('pos/setClient', value)
			}
		},
		contactForNumber: {
			get() {
				return this.clientPhoneNumber
			},
			set(value) {
				this.$store.commit('pos/setContactNumber', value)
			}
		},
		...mapState([
			'userDepCurrencyName', 'userDepCurrencyId', 'userDepCurrencyCode'
		]),
		...mapState('pos', ['clientPhoneNumber', 'clientName', 'orderNumber', 'isOnlaynProdaja', 'clientAddress']),
		...mapState('references', [
			'allPaymentMethods', 'bankCardPaymentMethods'
		]),
		...mapState('certificates', [
			'certificateForPos', 'certificateError', 'certificateLoading'
		]),
		isCertificateComputed() {
			return this.isCertificate;
		},
		// totalPaid() {
		// 	let totalPaidTemp = 0.00
		// 	let vm = this
		// 	this.payments.forEach(payment => {
		//
		// 		/*
		// 		* IF CURRENCIES ARE THE SAME */
		// 		if (payment.currency.id == vm.userDepCurrencyId) {
		//
		// 			/*totalPaidTemp += payment.paymentMethods.reduce(function (prev, cur) {
		// 				if (cur.amount.toString().trim() !== '' && cur.paymentMethod.code !== 'QARZGA' && cur.paymentMethod.code !== 'HOMIYLIK') {
		//
		// 					return parseFloat((prev + precisionRoundMod(cur.amount, 2)).toFixed(2))
		// 					// return prev + parseFloat(cur.amount);
		// 				} else {
		// 					return prev
		// 				}
		// 			}, 0);*/
		// 			payment.paymentMethods.forEach(pMethod => {
		// 				if (pMethod.amount.toString().trim() !== '' && pMethod.paymentMethod.code !== 'QARZGA' && pMethod.paymentMethod.code !== 'HOMIYLIK') {
		//
		// 					totalPaidTemp = parseFloat((totalPaidTemp + precisionRoundMod(pMethod.amount, 2)).toFixed(2))
		// 				}
		// 			})
		// 		}
		// 		/*
		// 		* IF CURRENCIES ARE DIFFERENT ADN IT IS UZS */
		// 		else if (payment.currency.code === 'UZS') {
		//
		// 			let foundIndex = vm.lastCurrencyRates.findIndex(currency => currency.currencyCode == vm.userDepCurrencyCode)
		// 			let currencyRateToUzs = foundIndex > -1 ? vm.lastCurrencyRates[foundIndex].rate : 0
		// 			/*totalPaidTemp += payment.paymentMethods.reduce(function (prev, cur) {
		// 				if (cur.amount.toString().trim() !== '' && cur.paymentMethod.code !== 'QARZGA' && cur.paymentMethod.code !== 'HOMIYLIK') {
		// 					return parseFloat((prev + precisionRoundMod(cur.amount / currencyRateToUzs, 2)).toFixed(2))
		// 					// return prev + (parseFloat(cur.amount) / currencyRateToUzs);
		// 				} else {
		// 					return prev
		// 				}
		// 			}, 0);*/
		// 			payment.paymentMethods.forEach(pMethod => {
		// 				if (pMethod.amount.toString().trim() !== '' && pMethod.paymentMethod.code !== 'QARZGA' && pMethod.paymentMethod.code !== 'HOMIYLIK') {
		//
		// 					totalPaidTemp = parseFloat((totalPaidTemp + precisionRoundMod(pMethod.amount / currencyRateToUzs, 2)).toFixed(2));
		// 				}
		// 			})
		// 		}
		// 		/*
		// 		* IF CURRENCIES ARE DIFFERENT ADN IT IS NOT UZS */
		// 		else {
		//
		// 			let currencyRateRatioToDep = vm.lastCurrencyRates.find(c => c.currencyId === payment.currency.id) ? vm.lastCurrencyRates.find(c => c.currencyId === payment.currency.id).ratioToDepCurrencyRate : 0
		// 			/*totalPaidTemp += payment.paymentMethods.reduce(function (prev, cur) {
		// 				if (cur.amount.toString().trim() !== '' && cur.paymentMethod.code !== 'QARZGA' && cur.paymentMethod.code !== 'HOMIYLIK') {
		// 					return parseFloat((prev + precisionRoundMod(cur.amount / currencyRateRatioToDep, 2)).toFixed(2))
		// 					// return prev + (parseFloat(cur.amount) / currencyRateRatioToDep);
		// 				} else {
		// 					return prev
		// 				}
		// 			}, 0);*/
		// 			payment.paymentMethods.forEach(pMethod => {
		// 				if (pMethod.amount.toString().trim() !== '' && pMethod.paymentMethod.code !== 'QARZGA' && pMethod.paymentMethod.code !== 'HOMIYLIK') {
		//
		// 					totalPaidTemp = parseFloat((totalPaidTemp + precisionRoundMod(pMethod.amount / currencyRateRatioToDep, 2)).toFixed(2))
		// 				}
		// 			})
		// 		}
		// 	})
		// 	return parseFloat(totalPaidTemp.toFixed(2));
		// },
		totalPaid() {
			let totalPaidTemp = 0.00
			let vm = this
			this.payments.forEach(payment => {

				/*
				* IF CURRENCIES ARE THE SAME */
				if (payment.currency.id == vm.userDepCurrencyId) {
					payment.paymentMethods.forEach(pMethod => {
						if (pMethod.amount.toString().trim() !== '' && pMethod.paymentMethod.code !== 'QARZGA' && pMethod.paymentMethod.code !== 'HOMIYLIK') {

							totalPaidTemp = parseFloat((totalPaidTemp + pMethod.amount))
						}
					})
				}
				/*
				* IF CURRENCIES ARE DIFFERENT ADN IT IS UZS */
				else if (payment.currency.code === 'UZS') {

					let foundIndex = vm.lastCurrencyRates.findIndex(currency => currency.currencyCode == vm.userDepCurrencyCode)
					let currencyRateToUzs = foundIndex > -1 ? vm.lastCurrencyRates[foundIndex].rate : 0

					payment.paymentMethods.forEach(pMethod => {
						if (pMethod.amount.toString().trim() !== '' && pMethod.paymentMethod.code !== 'QARZGA' && pMethod.paymentMethod.code !== 'HOMIYLIK') {

							totalPaidTemp = parseFloat((totalPaidTemp + pMethod.amount / currencyRateToUzs));
						}
					})
				}
				/*
				* IF CURRENCIES ARE DIFFERENT ADN IT IS NOT UZS */
				else {

					let currencyRateRatioToDep = vm.lastCurrencyRates.find(c => c.currencyId === payment.currency.id) ? vm.lastCurrencyRates.find(c => c.currencyId === payment.currency.id).ratioToDepCurrencyRate : 0

					payment.paymentMethods.forEach(pMethod => {
						if (pMethod.amount.toString().trim() !== '' && pMethod.paymentMethod.code !== 'QARZGA' && pMethod.paymentMethod.code !== 'HOMIYLIK') {

							totalPaidTemp = parseFloat((totalPaidTemp + (pMethod.amount / currencyRateRatioToDep)))
						}
					})
				}
			})
			return parseFloat(totalPaidTemp);
		},
		computedDebtAmount() {
			/*if (this.payments.length > 0) {
				return this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount !== '' ? this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount : 0;
			}*/
			return 0;
		},
		computedSponsorshipAmount() {
			/*if (this.payments.length > 0) {
				return this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount !== '' ? this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount : 0;
			}*/
			return 0;
		}
	},
	async mounted() {
		await this.addNewPayment();
		// this.dropdowns.allMethods = this.allPaymentMethods;
	},
	watch: {
		isCertificate: {
			handler(newBoolean) {
				if (newBoolean) {
					setTimeout(() => {
						this.$refs.certificateRef.focus();
					}, 100);
				} else {
					/*this.$store.commit('certificates/posCertificateError', {message: null})
					this.payments.find(el => el.paymentMethod.code == 'CERTIFICATE').certificate = '';
					this.payments.find(el => el.paymentMethod.code == 'CERTIFICATE').amount = 0;*/
				}
			}
		},
		computedDebtAmount: {
			handler() {
				this.$emit('debtAmountChanged', this.computedDebtAmount);
			}
		},
		computedSponsorshipAmount: {
			handler() {
				this.$emit('sponsorshipAmountChanged', this.computedSponsorshipAmount);
			}
		},
		isDebt: {
			handler(newBoolean) {
				/*if (newBoolean) {
					this.isSponsor = false
					this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount = parseFloat(this.totalSum) - this.totalPaid > 0 ? parseFloat(this.totalSum) - this.totalPaid : 0;
					this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount = 0;
					setTimeout(() => {
						this.$refs.QARZGA.focus();
					}, 100);
				} else {
					this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount = 0;
				}*/
			}
		},
		isSponsor: {
			handler(newBoolean) {
				if (newBoolean) {
					this.isDebt = false
					// this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount = parseInt(this.totalSum) - this.totalPaid > 0 ? parseInt(this.totalSum) - this.totalPaid : 0;
					// this.changePaymentAmounts('HOMIYLIK');
					setTimeout(() => {
						this.$refs.HOMIYLIK.focus();
					}, 100);
				} else {
					// this.changePaymentAmounts('CASH');
					/*this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount = 0;
					setTimeout(() => {
						this.$refs.CASH.focus();
					}, 100);*/
				}
			}
		},
		openClicked: {
			handler(newVal) {
				if (newVal) {
					this.isCertificate = false;
					this.isDebt = false;
					this.isSponsor = false;
					this.paymentComment = '';
					this.payments = [];
					// this.addNewPayment();
					/*if (this.allPaymentMethods.length > 1) {
						this.payments = [];
						this.addNewPayment();
					}
					setTimeout(() => {
						this.payments.find(el => el.paymentMethod.code == 'CASH').amount = parseFloat(this.totalSum);
						this.$refs.CASH.focus();
					}, 100);*/
				}
			}
		},
		saleCurrencies: {
			handler(newVal) {
				this.addNewPayment()
			}
		},
		payments: {
			handler: function (val, oldVal) {
				/*this.payments.forEach(el => {
					if (this.certificateForPos) {
						if (el.paymentMethod.code == 'CERTIFICATE' && el.amount.toString().trim() !== '') {
							if (parseFloat(el.amount) > parseFloat(this.certificateForPos.balance)) {
								el.amount = this.certificateForPos.balance;
							} else if (el.amount < 0) {
								el.amount = 0;
							}
						}
					}
				});
				if (parseFloat(this.totalPaid) >= parseFloat(this.totalSum)) {
					Vue.set(this.payments.find(el => el.paymentMethod.code == 'QARZGA'), 'amount', 0);
					Vue.set(this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK'), 'amount', 0);
				}*/
			},
			deep: true
		}
	},
	methods: {
		...mapActions('references', [
			'loadPaymentMethods'
		]),
		...mapActions('certificates', [
			'getCertificateByNumber'
		]),
		insert(number, model, find) {
			if (model.paymentMethods.find(method => method.paymentMethod.code === find).amount === 0) {
				model.paymentMethods.find(method => method.paymentMethod.code === find).amount = number
			} else {
				model.paymentMethods.find(method => method.paymentMethod.code === find).amount += number
			}
		},
		trash(model, find) {
			model.paymentMethods.find(method => method.paymentMethod.code === find).amount = model.paymentMethods.find(method => method.paymentMethod.code === find).amount.substring(0, model.paymentMethods.find(method => method.paymentMethod.code === find).amount.length - 1)
		},
		makeAndReturnPaymentMethods(currency) {
			let tmpPaymentMethods = []
			for (let i = 0; i < this.allPaymentMethods.length; i++) {
				let obj = {
					amount: 0,
					paymentMethod: JSON.parse(JSON.stringify(this.allPaymentMethods[i])),
					certificate: '',
					certificateId: null,
					text: '',
					currencyId: currency.id,
					currencyRateId: this.lastCurrencyRates.find(c => c.currencyCode === currency.code) ? this.lastCurrencyRates.find(c => c.currencyCode === currency.code).id : null
				}
				if (obj.paymentMethod.code === 'BANK_CARD' && currency.code === 'USD') {
					let obj2ForHumo = JSON.parse(JSON.stringify(obj))
					obj2ForHumo.paymentMethod = JSON.parse(JSON.stringify(this.bankCardPaymentMethods.find(el => el.code === 'HUMO')))
					tmpPaymentMethods.push(obj2ForHumo)
					obj.paymentMethod = JSON.parse(JSON.stringify(this.bankCardPaymentMethods.find(el => el.code === 'VISA')))
				}
				if (obj.paymentMethod.code === 'BANK_CARD' && currency.code === 'UZS') {
					let obj2ForHumo = JSON.parse(JSON.stringify(obj))
					obj2ForHumo.paymentMethod = JSON.parse(JSON.stringify(this.bankCardPaymentMethods.find(el => el.code === 'HUMO')))
					tmpPaymentMethods.push(obj2ForHumo)
					obj.paymentMethod = JSON.parse(JSON.stringify(this.bankCardPaymentMethods.find(el => el.code === 'UZCARD')))
				}
				tmpPaymentMethods.push(obj)
			}
			return tmpPaymentMethods
		},
		addNewPayment() {
			if (this.payments.length > 0 && this.saleCurrencies.length <= this.payments.length) {
				this.payments = this.payments.filter(payment => {
					let index = this.saleCurrencies.findIndex(el => el.code === payment.currency.code)
					if (index >= 0) {
						return payment;
					}
				})
			} else {
				if (this.saleCurrencies.length > 0 && this.saleCurrencies.length > this.payments.length) {
					this.saleCurrencies.forEach(currency => {
						let idxInPayments = this.payments.findIndex(p => p.currency.code === currency.code)
						if (idxInPayments < 0) {
							let paymentObj = {
								currency: currency,
								paymentMethods: []
							}
							if (this.lastCurrencyRates.length === 0) {
								setTimeout(() => {
									paymentObj.paymentMethods = paymentObj.paymentMethods.concat(this.makeAndReturnPaymentMethods(currency))
									this.payments.push(paymentObj)
								}, 1500)
							} else {
								/*for (let i = 0; i < this.allPaymentMethods.length; i++) {
									let obj = {
										amount: 0,
										paymentMethod: JSON.parse(JSON.stringify(this.allPaymentMethods[i])),
										certificate: '',
										certificateId: null,
										text: '',
										currencyId: currency.id,
										currencyRateId: this.lastCurrencyRates.find(c => c.currencyCode === currency.code) ? this.lastCurrencyRates.find(c => c.currencyCode === currency.code).id : null
									}
									if (obj.paymentMethod.code === 'BANK_CARD' && currency.code === 'USD') {
										obj.paymentMethod.code = 'VISA'
									}
									if (obj.paymentMethod.code === 'BANK_CARD' && currency.code === 'UZS') {
										let obj2ForHumo = JSON.parse(JSON.stringify(obj))
										obj2ForHumo.paymentMethod.code = 'HUMO'
										paymentObj.paymentMethods.push(obj2ForHumo)
										obj.paymentMethod.code = 'UZCARD'
									}
									paymentObj.paymentMethods.push(obj)
								}*/
								paymentObj.paymentMethods = paymentObj.paymentMethods.concat(this.makeAndReturnPaymentMethods(currency))
								this.payments.push(paymentObj)
							}
						}
					})
				}
			}
		},
		async getCertificateForPayment() {
			/*let certificateNumber = this.payments.find(el => el.paymentMethod.code == 'CERTIFICATE').certificate;
			if (certificateNumber.length == 4) {
				this.$store.commit('certificates/setCertificateLoading', true);
				await this.getCertificateByNumber(certificateNumber)
				if (this.certificateError) {
					this.$store.commit('certificates/resetCertificateForPos')
					this.payments.find(el => el.paymentMethod.code == 'CERTIFICATE').amount = 0;
					this.$refs.certificateRef.$el.setSelectionRange(0, this.$refs.certificateRef.$el.value.length)
				} else if (this.certificateForPos) {
					this.$refs.CERTIFICATE.focus()
				}
			} else {
				this.$vs.notify({
					title: 'Номер сертификата должен быть четырехзначным',
					color: 'warning',
					icon: 'close',
					position: 'top-right'
				});
				this.$store.commit('certificates/posCertificateError', {message: null})
				this.payments.find(el => el.paymentMethod.code == 'CERTIFICATE').amount = 0;
				this.$refs.certificateRef.$el.setSelectionRange(0, this.$refs.certificateRef.$el.value.length)
			}*/
		},
		giveRestSumToPayment(paymentIndex, paymentMethodCode) {
			/*
			* IF PAYMENT_METHOD ALREADY HAVE SOME VALUE */
			if (this.payments[paymentIndex].paymentMethods.find(el => el.paymentMethod.code === paymentMethodCode).amount > 0)
				this.payments[paymentIndex].paymentMethods.find(el => el.paymentMethod.code === paymentMethodCode).amount = 0

			/*
				* IF CURRENCIES ARE THE SAME */
			if (this.payments[paymentIndex].currency.code === this.userDepCurrencyCode) {
				this.payments[paymentIndex].paymentMethods.find(el => el.paymentMethod.code === paymentMethodCode).amount = (this.totalSum - this.totalPaid).toFixed(2)
			}
			/*
			* IF CURRENCIES ARE DIFFERENT ADN IT IS UZS */
			else if (this.payments[paymentIndex].currency.code === 'UZS') {
				let foundIndex = this.lastCurrencyRates.findIndex(currency => currency.currencyCode === this.userDepCurrencyCode)
				let currencyRateToUzs = foundIndex > -1 ? this.lastCurrencyRates[foundIndex].rate : 0
				this.payments[paymentIndex].paymentMethods.find(el => el.paymentMethod.code === paymentMethodCode).amount
					= this.roundUZS((currencyRateToUzs * (this.totalSum - this.totalPaid)).toFixed(2))
			}
			/*
			* IF CURRENCIES ARE DIFFERENT ADN IT IS NOT UZS */
			else {
				let currencyRateRatioToDep = this.lastCurrencyRates.find(c => c.currencyId === this.payments[paymentIndex].currency.id) ? this.lastCurrencyRates.find(c => c.currencyId === this.payments[paymentIndex].currency.id).ratioToDepCurrencyRate : 0
				this.payments[paymentIndex].paymentMethods.find(el => el.paymentMethod.code === paymentMethodCode).amount = ((this.totalSum - this.totalPaid) * currencyRateRatioToDep).toFixed(2)
			}
			this.confirmLastElementCode = paymentMethodCode;
			this.lastElementCode = paymentMethodCode;
		},
		roundUZS(sum) {
			let v = Math.floor(sum % 100);
			if (v > 50) {
				return (Math.floor(sum / 100) + 1) * 100;
			} else {
				return Math.floor(sum / 100) * 100 + 50;
			}
		},
		giveTotalSumToPayment(paymentMethodCode) {
			if (paymentMethodCode === 'CERTIFICATE') {
				if (this.certificateForPos) {
					if (parseFloat(this.certificateForPos.balance) >= parseFloat(this.totalSum)) {
						this.changePaymentAmounts(paymentMethodCode);
						this.confirmLastElementCode = paymentMethodCode;
						this.lastElementCode = paymentMethodCode;
						// this.$refs[paymentMethodCode].$el.setSelectionRange(0, this.$refs[paymentMethodCode].$el.value.length)
					}
					this.$refs[paymentMethodCode].focus();
				} else {
					this.$refs.certificateRef.focus();
				}
			} else {
				this.changePaymentAmounts(paymentMethodCode);
				this.confirmLastElementCode = paymentMethodCode;
				this.lastElementCode = paymentMethodCode;
				this.$refs[paymentMethodCode].focus();
				// this.$refs[paymentMethodCode].$el.setSelectionRange(0, this.$refs[paymentMethodCode].$el.value.length)
			}
		},
		changePaymentAmounts(paymentMethodCode) {
			/*this.payments.forEach(payment => {
				if (payment.paymentMethod.code == paymentMethodCode) {
					payment.amount = this.totalSum;
				} else {
					payment.amount = 0;
				}
			})*/
		},
		async handleInputMoney($event, paymentMethodCode) {
			/** --FOR QARZGA-- **/
			/*if (paymentMethodCode == 'QARZGA') {
				if ($event.trim() !== '') {
					if (this.lastElementCode !== "HOMIYLIK") {
						await this.changePaymentAmounts(this.lastElementCode)
					}
					this.payments.forEach(el => {
						// if (parseFloat(el.amount) >= parseFloat(this.totalPaid)) {
						if (el.paymentMethod.code !== 'QARZGA' && parseFloat(this.totalSum) >= parseFloat($event)) {
							if (this.lastElementCode == this.confirmLastElementCode && el.paymentMethod.code == this.confirmLastElementCode) {

								Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseFloat(this.totalSum) - parseFloat($event))
								this.lastDebtInput = $event;
								this.lastElementCode = el.paymentMethod.code;
							}
						} else {
							this.confirmLastElementCode = this.lastElementCode
							Vue.set(this.payments.find(el => el.paymentMethod.code == 'QARZGA'), 'amount', parseFloat(this.lastDebtInput))
						}
						// }
					});
					let foundIndex = this.payments.findIndex(el => {
						return el.amount > 0 && el.amount !== '' && el.paymentMethod.code !== 'QARZGA'
					});
					if (foundIndex == -1) {
						this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount = $event;
					}
				} else {
					Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseFloat(this.totalPaid) + parseFloat(this.lastDebtInput))
				}
				if (parseFloat(this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount !== '' ?
					this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount :
					0) > parseFloat(this.totalPaid)) {
					this.payments.find(el => el.paymentMethod.code == 'QARZGA').amount = parseFloat(this.lastDebtInput);
				}
			}
			/!** --FOR HOMIYLIK-- **!/
			if (paymentMethodCode == 'HOMIYLIK') {
				if ($event.trim() !== '') {
					if (this.lastElementCode !== "QARZGA") {
						await this.changePaymentAmounts(this.lastElementCode)
					}
					this.payments.forEach(el => {
						// if (parseInt(el.amount) >= parseInt(this.totalPaid)) {
						if (el.paymentMethod.code !== 'HOMIYLIK' && parseFloat(this.totalSum) >= parseFloat($event)) {
							if (this.lastElementCode == this.confirmLastElementCode && el.paymentMethod.code == this.confirmLastElementCode) {
								Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseFloat(this.totalSum) - parseFloat($event))
								this.lastSponsorInput = $event;
								this.lastElementCode = el.paymentMethod.code;
							}
						} else {
							this.confirmLastElementCode = this.lastElementCode
							Vue.set(this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK'), 'amount', parseFloat(this.lastSponsorInput))
						}
						// }
					});
					let foundIndex = this.payments.findIndex(el => {
						return el.amount > 0 && el.amount !== '' && el.paymentMethod.code !== 'HOMIYLIK'
					});
					if (foundIndex == -1) {
						this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount = $event;
					}
				} else {
					Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseInt(this.totalPaid) + parseInt(this.lastSponsorInput))
				}
				if (parseFloat(this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount !== '' ?
					this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount :
					0) > parseFloat(this.totalPaid)) {
					this.payments.find(el => el.paymentMethod.code == 'HOMIYLIK').amount = parseFloat(this.lastSponsorInput);
				}
			}*/
			/** --FOR CERTIFICATE-- **/
			/*if (paymentMethodCode == 'CERTIFICATE') {
				if ($event.trim() !== '') {
					this.payments.forEach(el => {
						if (parseInt(el.amount) >= parseInt(this.totalPaid)) {
							if (el.paymentMethod.code !== paymentMethodCode && parseInt(this.totalSum) >= parseInt($event)) {
								if (this.lastElementCode == this.confirmLastElementCode && el.paymentMethod.code == this.confirmLastElementCode) {
									Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseInt(this.totalSum) - parseInt($event))
									this.lastDebtInput = $event;
									this.lastElementCode = el.paymentMethod.code;
								}
							} else {
								this.confirmLastElementCode = this.lastElementCode
								Vue.set(this.payments.find(el => el.paymentMethod.code == paymentMethodCode), 'amount', parseInt(this.lastDebtInput))
							}
						}
					});
					let foundIndex = this.payments.findIndex(el => {
						return el.amount > 0 && el.amount !== '' && el.paymentMethod.code !== paymentMethodCode
					});
					if (foundIndex == -1) {
						this.payments.find(el => el.paymentMethod.code == paymentMethodCode).amount = $event;
					}
				} else {
					Vue.set(this.payments.find(el => el.paymentMethod.code == this.lastElementCode), 'amount', parseInt(this.totalPaid) + parseInt(this.lastDebtInput))
				}
				if (parseInt(this.payments.find(el => el.paymentMethod.code == paymentMethodCode).amount !== '' ?
					this.payments.find(el => el.paymentMethod.code == paymentMethodCode).amount :
					0) > parseInt(this.totalPaid)) {
					this.payments.find(el => el.paymentMethod.code == paymentMethodCode).amount = parseInt(this.lastDebtInput);
				}
			}*/
		}
	}
}
</script>

<style scoped lang="scss">
input {
	font-size: 20px;
	color: #d1d1d1;
	font-weight: 400;

	&.number-input {
		width: 100%;
		height: 55px;
		line-height: 55px;
		text-align: center;
		padding: 0 20px;
		border-radius: 10px;
		border: 0;
		-webkit-box-shadow: 0px 0px 17px -1px rgba(132, 132, 132, 0.15);
		-moz-box-shadow: 0px 0px 17px -1px rgba(132, 132, 132, 0.15);
		box-shadow: 0px 0px 17px -1px rgba(132, 132, 132, 0.15);
	}
}

.wrapper {
	width: 100%;
	background-color: #97a0b3;

	.phone {
		width: 350px;
		margin: 40px auto 0 auto;
		position: relative;

		span.title {
			font-weight: 700;
			letter-spacing: 2px;
			display: block;
			text-align: center;
		}

		.phone-container {
			width: 100%;
			margin-top: 30px;

			.keyboard {
				width: 90%;
				margin-left: 5%;
				margin-top: 40px;

				.number {
					width: 100%;
					font-size: 0;
					text-align: center;

					&.aling-right {
						text-align: right;
						width: 100%;
					}

					span {
						font-size: 24px;
						color: #E4BF88;
						display: inline-block;;
						width: 33%;
						text-align: center;
						margin-bottom: 25px;

						&.call-button {
							opacity: 0;
							transition: 250ms;

							&.show {
								opacity: 1;
							}

							img {
								display: inline-block;
								vertical-align: middle;
							}
						}

						i {
							display: inline-block;
							width: 80px;
							height: 80px;
							line-height: 80px;
							background: white;
							cursor: pointer;
							border-radius: 100%;
							transition: 250ms;
							-webkit-touch-callout: none;
							-webkit-user-select: none;
							-khtml-user-select: none;
							-moz-user-select: none;
							-ms-user-select: none;
							user-select: none;

							-webkit-box-shadow: 8px 8px 24px 0px rgba(132, 132, 132, 0.09);
							-moz-box-shadow: 8px 8px 24px 0px rgba(132, 132, 132, 0.09);
							box-shadow: 8px 8px 24px 0px rgba(132, 132, 132, 0.09);

							&.delete {
								background: transparent;
								box-shadow: 0 0 0 0;
								-webkit-box-shadow: 0 0 0 0;
								-moz-box-shadow: 0 0 0 0;
								-ms-box-shadow: 0 0 0 0;
								color: #E4BF88;

								img {
									display: inline-block;
									vertical-align: middle;
								}
							}
						}

						&:hover {
							i {
								color: black;
							}
						}

						&:active {
							i {
								transform: translateY(1px);

								-webkit-box-shadow: 5px 5px 24px 0px rgba(132, 132, 132, 0.18);
								-moz-box-shadow: 5px 5px 16px 0px rgba(132, 132, 132, 0.18);
								box-shadow: 5px 5px 16px 0px rgba(132, 132, 132, 0.18);

								&.delete {
									box-shadow: 0 0 0 0;
									-webkit-box-shadow: 0 0 0 0;
									-moz-box-shadow: 0 0 0 0;
									-ms-box-shadow: 0 0 0 0;
									transform: translateY(0px);

									img {
										transtiion: 250ms;
									}

									&:active {
										img {
											transform: translateY(2px);

										}
									}

								}
							}
						}
					}
				}
			}
		}
	}
}
</style>

<style scoped lang="scss">
.box-body-payment {
	margin-bottom: 10px;

	label {
		margin-bottom: 4px;
		font-size: 1.3rem;
		font-weight: bold;
	}
}

.mt50 {
	margin-top: -25px;
}
.uzsTop {
	margin-top: 25px;
}

.paymentTitle {
	border-bottom: 1px solid grey;
	color: #4DBD74;

	span {
		font-size: 1.3rem;
	}
}

.posPaymentInputGroup {
	height: 2.5rem;

	.input-group-prepend {
		.input-group-text {
			cursor: pointer;
			font-size: 1rem;
		}
	}

	input {
		height: 2.5rem;
		font-size: 1rem;
	}
}

#paymentsComment {
	font-size: 1rem;
}

.spinner-border {
	-webkit-border-radius: 50%;
	-moz-border-radius: 50%;
	border-radius: 50% !important;
}

td .form-control {
	height: unset;
}

.fa-2x {
	font-size: 2em;
}

.btn-box-tool:hover {
	color: #606c84;
}

.btn-box-tool {
	padding: 5px;
	font-size: 20px;
	background: transparent;
	color: #97a0b3;
}

.fa {
	display: inline-block;
	font: normal normal normal 14px/1 FontAwesome;
	font-size: inherit;
	text-rendering: auto;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
